import { render, staticRenderFns } from "./MixProdutos.vue?vue&type=template&id=39242ce6&scoped=true"
import script from "./MixProdutos.vue?vue&type=script&lang=js"
export * from "./MixProdutos.vue?vue&type=script&lang=js"
import style0 from "./MixProdutos.vue?vue&type=style&index=0&id=39242ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39242ce6",
  null
  
)

export default component.exports